





































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

@Component({})

export default class FileDropArea extends Vue {
  @Prop()
  onChange!: Function;

  @Prop()
  onClick!: Function;

  @Prop()
  file!: File;

  @Prop()
  fileType!: string;

  @Prop()
  isDragOver!: boolean;
}

